import { addRecentlyViewedProduct } from 'utils/recently-viewed';

/**
 * Component that tracks product views for the recently viewed products feature.
 * This component should be included on all pages to ensure product views are tracked
 * regardless of whether the user scrolls to the recommendations section.
 */
export default () => {
  /**
   * Tracks the current product view if on a product page
   */
  const trackProductView = () => {
    // Check if we're on a product page
    const isProductPage = window.location.pathname.includes('/products/');

    if (isProductPage) {
      const currentHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
      const inventory = document.querySelector<HTMLScriptElement>('[data-inventory]');

      let inventoryItem = null;
      if (inventory && inventory.textContent) {
        try {
          const inventoryData = JSON.parse(inventory.textContent.trim());
          inventoryItem = inventoryData.inventoryItem;
        } catch (e) {
          // Silently fail if JSON parsing errors occur
        }
      }

      if (currentHandle) {
        addRecentlyViewedProduct(currentHandle, inventoryItem);
      }
    }
  };

  trackProductView();
};
